import { FormControl, MenuItem, Select } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CustomDatePicker from '../../../../addContact/datePicker/CustomDatePicker';
import { timeIntervalOptions } from './SendTypeStep';

const CustomDate = ({readyToSend, handleReadyToSendChange}) => {
    
    return(
        <div className='dmpc_4th_tab_day'>
            <div className='dmpc_4th_tab_day_inner'>
                <div className='dmpc_4th_tab_day_hour'>
                    <div className='dmpc_4th_tab_day_hour_inner'>
                        <span className='dmpc_4th_tab_day_hour_title'>Date</span>
                        <div className="day_select_formControll day_select_formControll_132">
                            <CustomDatePicker
                                value={readyToSend.date}
                                changeDate={(value) => handleReadyToSendChange({date: value})}
                            />
                        </div>
                    </div>
                </div>

                <div className='dmpc_4th_tab_day_hour'>
                    <div className='dmpc_4th_tab_day_hour_inner'>
                    <span className='dmpc_4th_tab_day_hour_title'>At</span>
                    <FormControl className="day_select_formControll day_select_formControll_97">
                        <Select
                            value={readyToSend.at_time} 
                            IconComponent={ExpandMoreIcon}
                            onChange={(e) => handleReadyToSendChange({at_time: e.target.value})}
                            className={"day_select_sf"}
                            displayEmpty
                            MenuProps={{
                                anchorOrigin: {
                                    vertical: "bottom",
                                    horizontal: "left"
                                },
                                transformOrigin: {
                                    vertical: "top",
                                    horizontal: "left"
                                },
                                getContentAnchorEl: null,
                            }}
                        >
                            <MenuItem value={null} className='dropdownhelper-menuitem-class' disabled >Time</MenuItem>
                            {timeIntervalOptions(15, MenuItem)}
                        </Select>
                    </FormControl>
                    </div>
                   
                </div>

            
            </div>
        </div>
    )
}
export default CustomDate;